import { Sun, Moon, Palette } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/contexts/ThemeContext'

interface ThemeDropdownProps {
  triggerClassName?: string
  triggerVariant?: 'secondary' | 'ghost' | 'outline'
}

export function ThemeDropdown({
  triggerClassName,
  triggerVariant = 'secondary',
}: ThemeDropdownProps) {
  const { theme, setTheme } = useTheme()

  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="h-4 w-4" />
      case 'dark':
        return <Moon className="h-4 w-4" />
      case 'oksolar-light':
      case 'oksolar-dark':
        return <Palette className="h-4 w-4" />
      default:
        return <Sun className="h-4 w-4" />
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={triggerVariant} size="icon" className={triggerClassName ?? 'h-9 w-9'}>
          {getIcon()}
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme('light')}>
          <Sun className="mr-2 h-4 w-4" />
          <span>Light</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          <Moon className="mr-2 h-4 w-4" />
          <span>Dark</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('oksolar-light')}>
          <Sun className="mr-2 h-4 w-4" />
          <span>OkSolar Light</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('oksolar-dark')}>
          <Moon className="mr-2 h-4 w-4" />
          <span>OkSolar Dark</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
